// extracted by mini-css-extract-plugin
export default {"text":"UserSpacePostpaidModal__text--3-6js"};